import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SerieLockedPaneProps {
  title: string;
}

/**
 * Placeholder zamčené vrstvy – ostatní vrstvy (Operation / Product cost / Calculation) zatím
 * nezpracováváme do detailu; jejich stav je vidět v pipeline a per-termín v tabulce.
 */
export function SerieLockedPane({ title }: SerieLockedPaneProps) {
  const { t } = useTranslation('venua-planner');
  return (
    <div className="border-phx-border-2 bg-phx-surface text-phx-text-muted rounded-phx-md gap-phx-2 flex flex-col items-center justify-center border border-dashed px-6 py-14 text-center">
      <Lock size={22} className="text-phx-text-faint" />
      <b className="text-phx-text-2 text-phx-md">{title}</b>
      <span className="text-phx-sm max-w-md leading-relaxed">
        {t('serieDetail.lockedPane.description')}
      </span>
    </div>
  );
}
